import { TaxPolicyWithNestedObjectResponseAuditableODataWithMetadataResponse } from 'src/app/web-api-client';
import { Collection } from '../../models';
import { TaxPolicy } from '../../models/tax-policy';
import { Mapper } from '@shared/helpers/mapper';
import { EntityType, InvestmentJurisdiction } from '@shared/models/entity';
import { TaxPolicyStatus } from '../../models/tax-policy-status';
import { SecurityType } from '@shared/models/security';

export const mapToTaxPoliciesFromResponse = (
  response: TaxPolicyWithNestedObjectResponseAuditableODataWithMetadataResponse
): Collection<TaxPolicy> => {
  return {
    total: response.odataCount ?? 0,
    items: Mapper.mapByList(response.value ?? [], TaxPolicy, [
      'name',
      'isActive',
      'taxPolicyId',
      'generalRate',
      {
        entityType: source =>
          Mapper.map(source.entityType, EntityType, ['entityTypeId', 'name']),
        investmentJurisdiction: source =>
          Mapper.map(source.investmentJurisdiction, InvestmentJurisdiction, [
            'investmentJurisdictionId',
            {
              name: source => source!.country!.name!,
            },
          ]),
        taxPolicyStatus: source =>
          Mapper.map(source.taxPolicyStatus, TaxPolicyStatus, [
            'taxPolicyStatusId',
            'name',
          ]),
        securityType: source =>
          Mapper.map(source.securityType, SecurityType, [
            'securityTypeId',
            'name',
          ]),
        taxRuleId: source => (source.taxRule ? source.taxRule.taxRuleId : 0),
      },
    ]),
  };
};
